// 프로젝트 관리 목업 데이터 - 농산물 박스 제조업

import type { Project, Task, Timesheet, Milestone } from '../types';

// 프로젝트 데이터 - 박스 개발/생산 프로젝트
export const projects: Project[] = [
  {
    id: 'PROJ001',
    code: 'PRJ-2025-001',
    name: '감귤박스 신규 디자인 개발',
    status: 'active',
    priority: 'high',
    customerId: 'CUST002',
    customerName: '서귀포감귤농협',
    projectManager: 'user-001',
    projectManagerName: '홍길동',
    startDate: '2025-01-15',
    endDate: '2025-03-31',
    progress: 35,
    budget: 25000000,
    actualCost: 8500000,
    description: '제주 감귤 브랜드 이미지 강화를 위한 신규 박스 디자인 개발',
    department: '디자인팀',
    createdAt: '2025-01-10',
    updatedAt: '2025-01-27',
  },
  {
    id: 'PROJ002',
    code: 'PRJ-2025-002',
    name: '딸기박스 프리미엄 라인 개발',
    status: 'active',
    priority: 'critical',
    customerId: 'CUST003',
    customerName: '논산딸기영농조합',
    projectManager: 'user-002',
    projectManagerName: '김영수',
    startDate: '2025-01-20',
    endDate: '2025-02-28',
    progress: 45,
    budget: 18000000,
    actualCost: 7200000,
    description: '고급 딸기 선물세트용 프리미엄 박스 라인 개발',
    department: '디자인팀',
    createdAt: '2025-01-15',
    updatedAt: '2025-01-27',
  },
  {
    id: 'PROJ003',
    code: 'PRJ-2025-003',
    name: '생산라인 자동화 개선',
    status: 'planning',
    priority: 'medium',
    projectManager: 'user-001',
    projectManagerName: '홍길동',
    startDate: '2025-02-01',
    endDate: '2025-05-31',
    progress: 0,
    budget: 120000000,
    actualCost: 0,
    description: '인쇄기 및 제함기 자동화 시스템 도입',
    department: '생산팀',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-20',
  },
  {
    id: 'PROJ004',
    code: 'PRJ-2024-012',
    name: '사과박스 표준화 프로젝트',
    status: 'completed',
    priority: 'medium',
    customerId: 'CUST001',
    customerName: '충주사과영농조합',
    projectManager: 'user-002',
    projectManagerName: '김영수',
    startDate: '2024-10-01',
    endDate: '2024-12-31',
    progress: 100,
    budget: 15000000,
    actualCost: 13800000,
    description: '사과박스 5kg/10kg 규격 표준화 및 디자인 통일',
    department: '디자인팀',
    createdAt: '2024-09-25',
    updatedAt: '2024-12-31',
  },
  {
    id: 'PROJ005',
    code: 'PRJ-2025-004',
    name: '친환경 포장재 연구',
    status: 'on_hold',
    priority: 'high',
    projectManager: 'user-001',
    projectManagerName: '홍길동',
    startDate: '2025-01-25',
    endDate: '2025-06-30',
    progress: 15,
    budget: 35000000,
    actualCost: 5200000,
    description: '친환경 재생지 및 수성 잉크 적용 연구 (원자재 공급 대기 중)',
    department: '연구개발팀',
    createdAt: '2025-01-22',
    updatedAt: '2025-01-26',
  },
];

// 작업 데이터 - 박스 개발 작업
export const tasks: Task[] = [
  {
    id: 'TASK001',
    code: 'TSK-001',
    name: '감귤박스 시장조사',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    status: 'completed',
    priority: 'high',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    startDate: '2025-01-15',
    endDate: '2025-01-20',
    expectedHours: 40,
    actualHours: 38,
    progress: 100,
    description: '경쟁사 감귤박스 디자인 분석 및 트렌드 조사',
    createdAt: '2025-01-15',
    updatedAt: '2025-01-20',
  },
  {
    id: 'TASK002',
    code: 'TSK-002',
    name: '디자인 컨셉 개발',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    status: 'in_progress',
    priority: 'high',
    assignedTo: 'user-001',
    assignedToName: '홍길동',
    startDate: '2025-01-21',
    endDate: '2025-02-05',
    expectedHours: 80,
    actualHours: 45,
    progress: 60,
    description: '제주 감귤 브랜드 아이덴티티 반영 디자인 시안 작업',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-27',
  },
  {
    id: 'TASK003',
    code: 'TSK-003',
    name: '인쇄판 제작',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    status: 'pending_review',
    priority: 'medium',
    assignedTo: 'user-003',
    assignedToName: '이생산',
    startDate: '2025-01-22',
    endDate: '2025-02-10',
    expectedHours: 60,
    actualHours: 55,
    progress: 90,
    description: '플렉소 인쇄판 제작 및 색상 테스트',
    createdAt: '2025-01-21',
    updatedAt: '2025-01-27',
  },
  {
    id: 'TASK004',
    code: 'TSK-004',
    name: '샘플 생산',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    status: 'open',
    priority: 'high',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    startDate: '2025-02-06',
    endDate: '2025-02-20',
    expectedHours: 40,
    actualHours: 0,
    progress: 0,
    description: '시제품 50박스 생산 및 고객 피드백 수집',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-20',
  },
  {
    id: 'TASK005',
    code: 'TSK-005',
    name: '딸기박스 디자인 기획',
    projectId: 'PROJ002',
    projectName: '딸기박스 프리미엄 라인 개발',
    status: 'completed',
    priority: 'high',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    startDate: '2025-01-20',
    endDate: '2025-01-25',
    expectedHours: 30,
    actualHours: 32,
    progress: 100,
    description: '프리미엄 딸기박스 컨셉 기획 및 규격 결정',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-25',
  },
  {
    id: 'TASK006',
    code: 'TSK-006',
    name: '칸막이 설계',
    projectId: 'PROJ002',
    projectName: '딸기박스 프리미엄 라인 개발',
    status: 'in_progress',
    priority: 'high',
    assignedTo: 'user-002',
    assignedToName: '김영수',
    startDate: '2025-01-26',
    endDate: '2025-02-10',
    expectedHours: 50,
    actualHours: 20,
    progress: 40,
    description: '딸기 손상 방지용 특수 칸막이 구조 설계',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-27',
  },
];

// 타임시트 데이터
export const timesheets: Timesheet[] = [
  {
    id: 'TS001',
    code: 'TS-2025-001',
    employeeId: 'user-001',
    employeeName: '홍길동',
    status: 'approved',
    startDate: '2025-01-20',
    endDate: '2025-01-26',
    totalHours: 45,
    billingHours: 40,
    approvedBy: '김부장',
    approvedAt: '2025-01-27',
    entries: [
      {
        id: 'TSE001',
        date: '2025-01-20',
        projectId: 'PROJ001',
        projectName: '감귤박스 신규 디자인 개발',
        taskId: 'TASK002',
        taskName: '디자인 컨셉 개발',
        hours: 8,
        isBillable: true,
        description: '감귤박스 디자인 시안 3종 작업',
      },
      {
        id: 'TSE002',
        date: '2025-01-21',
        projectId: 'PROJ001',
        projectName: '감귤박스 신규 디자인 개발',
        taskId: 'TASK002',
        taskName: '디자인 컨셉 개발',
        hours: 9,
        isBillable: true,
        description: '고객사 미팅 및 피드백 반영',
      },
      {
        id: 'TSE003',
        date: '2025-01-22',
        projectId: 'PROJ001',
        projectName: '감귤박스 신규 디자인 개발',
        taskId: 'TASK002',
        taskName: '디자인 컨셉 개발',
        hours: 8,
        isBillable: true,
        description: '색상 보정 및 인쇄 테스트 파일 준비',
      },
    ],
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
  {
    id: 'TS002',
    code: 'TS-2025-002',
    employeeId: 'user-002',
    employeeName: '김영수',
    status: 'submitted',
    startDate: '2025-01-20',
    endDate: '2025-01-26',
    totalHours: 42,
    billingHours: 38,
    entries: [
      {
        id: 'TSE004',
        date: '2025-01-20',
        projectId: 'PROJ002',
        projectName: '딸기박스 프리미엄 라인 개발',
        taskId: 'TASK005',
        taskName: '딸기박스 디자인 기획',
        hours: 8,
        isBillable: true,
        description: '딸기박스 규격 검토 및 기획서 작성',
      },
      {
        id: 'TSE005',
        date: '2025-01-26',
        projectId: 'PROJ002',
        projectName: '딸기박스 프리미엄 라인 개발',
        taskId: 'TASK006',
        taskName: '칸막이 설계',
        hours: 10,
        isBillable: true,
        description: '완충 칸막이 3D 모델링 작업',
      },
    ],
    createdAt: '2025-01-27',
    updatedAt: '2025-01-27',
  },
];

// 마일스톤 데이터
export const milestones: Milestone[] = [
  {
    id: 'MS001',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    name: '디자인 시안 확정',
    dueDate: '2025-02-05',
    status: 'pending',
    description: '고객 승인 받은 최종 디자인 확정',
  },
  {
    id: 'MS002',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    name: '샘플 승인',
    dueDate: '2025-02-20',
    status: 'pending',
    description: '시제품 샘플 고객 검수 및 승인',
  },
  {
    id: 'MS003',
    projectId: 'PROJ001',
    projectName: '감귤박스 신규 디자인 개발',
    name: '양산 시작',
    dueDate: '2025-03-01',
    status: 'pending',
    description: '본격 양산 및 첫 출하',
  },
  {
    id: 'MS004',
    projectId: 'PROJ002',
    projectName: '딸기박스 프리미엄 라인 개발',
    name: '칸막이 설계 완료',
    dueDate: '2025-02-10',
    status: 'pending',
    description: '특수 완충 칸막이 설계 확정',
  },
  {
    id: 'MS005',
    projectId: 'PROJ002',
    projectName: '딸기박스 프리미엄 라인 개발',
    name: '시즌 전 납품 완료',
    dueDate: '2025-02-25',
    status: 'pending',
    description: '딸기 수확 시즌 전 첫 납품 완료',
  },
];

// 유틸리티 함수
export const getProjectById = (id: string): Project | undefined => {
  return projects.find((p) => p.id === id);
};

export const getTaskById = (id: string): Task | undefined => {
  return tasks.find((t) => t.id === id);
};

export const getTasksByProject = (projectId: string): Task[] => {
  return tasks.filter((t) => t.projectId === projectId);
};

export const getMilestonesByProject = (projectId: string): Milestone[] => {
  return milestones.filter((m) => m.projectId === projectId);
};

// 프로젝트 통계
export const getProjectStats = () => {
  const totalProjects = projects.length;
  const activeProjects = projects.filter((p) => p.status === 'active').length;
  const completedProjects = projects.filter((p) => p.status === 'completed').length;
  const onHoldProjects = projects.filter((p) => p.status === 'on_hold').length;

  const totalBudget = projects.reduce((sum, p) => sum + p.budget, 0);
  const totalActualCost = projects.reduce((sum, p) => sum + p.actualCost, 0);
  const budgetUtilization = totalBudget > 0 ? (totalActualCost / totalBudget) * 100 : 0;

  const totalTasks = tasks.length;
  const completedTasks = tasks.filter((t) => t.status === 'completed').length;
  const inProgressTasks = tasks.filter((t) => t.status === 'in_progress').length;
  const taskCompletionRate = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

  const upcomingMilestones = milestones.filter((m) => m.status === 'pending').length;
  const overdueMilestones = milestones.filter((m) => m.status === 'overdue').length;

  return {
    totalProjects,
    activeProjects,
    completedProjects,
    onHoldProjects,
    totalBudget,
    totalActualCost,
    budgetUtilization,
    totalTasks,
    completedTasks,
    inProgressTasks,
    taskCompletionRate,
    upcomingMilestones,
    overdueMilestones,
  };
};

// 프로젝트 상태별 통계
export const getProjectStatusStats = () => {
  const stats: Record<string, number> = {};
  projects.forEach((project) => {
    stats[project.status] = (stats[project.status] || 0) + 1;
  });
  return stats;
};

// 작업 상태별 통계
export const getTaskStatusStats = () => {
  const stats: Record<string, number> = {};
  tasks.forEach((task) => {
    stats[task.status] = (stats[task.status] || 0) + 1;
  });
  return stats;
};

// 이번 주 타임시트
export const getThisWeekTimesheets = () => {
  return timesheets.filter((ts) => ts.status === 'draft' || ts.status === 'submitted');
};

// 다가오는 마일스톤
export const getUpcomingMilestones = () => {
  const today = new Date().toISOString().split('T')[0];
  return milestones
    .filter((m) => m.status === 'pending' && m.dueDate >= today)
    .sort((a, b) => a.dueDate.localeCompare(b.dueDate))
    .slice(0, 5);
};
